import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/2025.webp';
import { validateResetCode } from '../../Api';

function ResetValidate() {
  const location = useLocation();
  const navigate = useNavigate();
  const canAccess = sessionStorage.getItem('canAccessValidate') === 'true';
   const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!canAccess) {       
      navigate('/forgot-password');
    }
   
  }, [canAccess, navigate]);

  // const message = location.state?.message;
  const email = location.state?.email;
  // Form data to handle reset code
  const [formData, setFormData] = useState({
    email: email,
    code: '',
  });

  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
       await validateResetCode(formData);
      // After success, navigate to the password reset page
      sessionStorage.removeItem('canAccessValidate');
      sessionStorage.setItem('canAccessReset', 'true');
      navigate('/reset-password', { state: { email: email } });
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message || 'Error validating the code.');
      } else {
        setError('Error validating the code.');
      }
    }finally {
        setLoading(false);
      }
  };

  return (
    <div className="login-page">
      <img src={Logo} alt="Filadelfia Blessing Family" className="logo" />
      {successMessage && <p className="success">{successMessage}</p>}
      {error && <p className="error">{error}</p>}
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="text"
            name="code" // Name should match formData key
            placeholder="Masukkan Kode Verifikasi"
            value={formData.code}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" disabled={loading}>{loading ? 'Verifikasi kode...' : 'Submit'}</button>
      </form>

           <div className="links">
      <a href="/"><span>Back to Login</span></a>
      </div>
    </div>
  );
}

export default ResetValidate;
